import { useQuery } from "@tanstack/react-query";
import AdvertisingService from "@/services/advertising";
import type {
  Advertisement,
  AdPage,
  PageAdsResponse,
} from "@/types/advertising";

interface UsePageAdsResult {
  bannerAds: Advertisement[];
  sidebarAds: Advertisement[];
  inFeedAds: Advertisement[];
  headerAds: Advertisement[];
  footerAds: Advertisement[];
  popupAds: Advertisement[];
  interstitialAds: Advertisement[];
  isLoading: boolean;
  error: unknown;
}

export const usePageAds = (page: AdPage, enabled = true): UsePageAdsResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["page-ads", page],
    queryFn: async () => {
      const response = await AdvertisingService.GetPageAds(page);
      return (response?.data || {}) as PageAdsResponse;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    bannerAds: data?.banner || [],
    sidebarAds: data?.sidebar || [],
    inFeedAds: data?.["in-feed"] || [],
    headerAds: data?.header || [],
    footerAds: data?.footer || [],
    popupAds: data?.popup || [],
    interstitialAds: data?.interstitial || [],
    isLoading,
    error,
  };
};
